/**
 * Get the canonical site URL for OAuth redirects and app navigation.
 *
 * CRITICAL: This is the single source of truth for app host resolution.
 * DO NOT use window.location.origin, VERCEL_URL, or dynamic URL resolution.
 *
 * Priority:
 * 1. NEXT_PUBLIC_SITE_URL (explicit override)
 * 2. Environment detection (production vs staging)
 *
 * Canonical hosts:
 * - Production: https://app.logosiq.ai
 * - Staging: https://staging.app.logosiq.ai
 * - BLOCKED: https://logosiq.ai (marketing site, not app)
 */
export function getCanonicalSiteUrl(): string {
  const explicitUrl = process.env.NEXT_PUBLIC_SITE_URL

  // Warn if logosiq.ai is used (marketing site, not app)
  if (explicitUrl === "https://logosiq.ai") {
    console.warn(
      "[v0][getCanonicalSiteUrl] WARNING: NEXT_PUBLIC_SITE_URL is set to marketing site (logosiq.ai). " +
        "Overriding to canonical app domain.",
    )
    return process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
      ? "https://app.logosiq.ai"
      : "https://staging.app.logosiq.ai"
  }

  // Use explicit URL if provided
  if (explicitUrl) {
    return explicitUrl
  }

  // Environment-based default
  return process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
    ? "https://app.logosiq.ai"
    : "https://staging.app.logosiq.ai"
}
